// export default Layout;
import React, { useState, useEffect }  from 'react';
import Header from './Header';
import Footer from './Footer';
import { Outlet } from 'react-router-dom';
import { toast ,ToastContainer} from "react-toastify";
import { t } from 'i18next';
// Import toastify css file
import { LanguageProvider } from './LanguageContext';
import "react-toastify/dist/ReactToastify.css";
import axios from 'axios';
import { useCart  } from "../components/CartContext";

const Layout = () => {
  const { cart, setCart, cartCount, setCartCount } = useCart();

  const totalAmount = cart
  .reduce((acc, item) => acc + item.price * item.quantity, 0)
  .toLocaleString();

  const incrementCartCount = () => {
    setCartCount((prevCount) => prevCount + 1);
  };
  const decrementCartCount = (id) => {
    setCart((prevCart) => {
      // Mise à jour de la quantité de l'article
      const updatedCart = prevCart
        .map((item) =>
          item.id === id
            ? {
                ...item,
                quantity: item.quantity > 1 ? item.quantity - 1 : item.quantity, // Si la quantité est supérieure à 1, on décrémente
              }
            : item
        )
        .filter((item) => item.quantity > 0); // Supprime l'article du panier si sa quantité devient 0
  
      // Si l'article est supprimé, réduire le compteur total d'articles
      setCartCount(updatedCart.reduce((acc, item) => acc + item.quantity, 0));
  
      return updatedCart;
    });
  };
  
  


  let toastId = null;
  const translateText = async (text, targetLanguage) => {
    if (targetLanguage === 'FR') {
      return text; // Si la langue cible est déjà le français, pas besoin de traduction
    }
  
    const apiKey = process.env.REACT_APP_DEEPL_API_KEY;
    const url = process.env.REACT_APP_DEEPL_URL;
  
    const params = new URLSearchParams();
    params.append("auth_key", apiKey);
    params.append("text", text);
    params.append("target_lang", targetLanguage); // Langue cible (FR, EN, ES, PT, etc.)
  
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: params,
      });
  
      const data = await response.json();
  
      if (data.translations && data.translations[0] && data.translations[0].text) {
        return data.translations[0].text;
      } else {
        console.error("Structure inattendue dans la réponse :", data);
        return text; // Retourne le texte original si la traduction échoue
      }
    } catch (error) {
      console.error("Erreur lors de la traduction :", error);
      return text; // Retourne le texte original en cas d'erreur
    }
  };

  const addToCart = async (id, name, price, type, img, des, stock) => {
    // Vérifie si l'article est en rupture de stock
    if (stock <= 0) {
      const lang = localStorage.getItem('language');
      const noStockMessage = await translateText(
        `${name} est en rupture de stock`,
        lang === "FRA" || lang === "FR"  || lang === "" ? 'FR' : lang === "ENG" ? 'EN' : lang === "ESP" ? 'ES' : 'PT'
      );
  
      toast.error(noStockMessage, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return; // Interrompt l'exécution si l'article est en rupture de stock
    }
  
    setCart((prevCart) => {
      const existingItem = prevCart.find((item) => item.id === id);
  
      if (existingItem) {
        // Si l'article existe déjà dans le panier et que la quantité est inférieure à 10
        if (existingItem.quantity < 10) {
          // Met à jour la quantité
          return prevCart.map((item) =>
            item.id === id ? { ...item, quantity: item.quantity + 1 } : item
          );
        } else {
          // Si la quantité atteint 10, affiche un toast d'échec et ne fait rien
          toast.error(`${name} ${t("10panier")}`, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          return prevCart; // Ne fait rien si la quantité atteint 10
        }
      }
  
      // Si l'article n'existe pas dans le panier, l'ajoute avec une quantité de 1
      const newCart = [...prevCart, { id, name, price, type, img, des, quantity: 1 }];
      return newCart;
    });
  
    // Si l'article a été ajouté avec succès, montre le toast de succès
    const lang = localStorage.getItem('language') || "FR";
    const newlang = lang === "FRA" || lang === "FR"  || lang === ""? 'FR' : lang === "ENG" ? 'EN' : lang === "ESP" ? 'ES' : 'PT';

    const messageTemplate = `${name} ajouté au panier pour ${Number(price).toLocaleString('fr-FR', { maximumFractionDigits: 0 })} FCFA`;

    const translatedMessage = await translateText(messageTemplate, newlang);

    // Seul si la quantité n'atteint pas 10, affiche le toast de succès
    setCart(prevCart => {
      const existingItem = prevCart.find(item => item.id === id);
      if (existingItem && existingItem.quantity < 10) {
        toast.success(translatedMessage, {
          position: "top-right",
          autoClose: 1000, // Le toast disparaît après 1 seconde
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
      return prevCart;
    });
  };
  
  

  const removeItemFromCart = (id) => {
    setCart((prevCart) => {
      // Filtrer pour supprimer tous les articles avec cet ID
      const updatedCart = prevCart.filter((item) => item.id !== id);
      // Mise à jour du compteur total d'articles dans le panier
      setCartCount(updatedCart.reduce((acc, item) => acc + item.quantity, 0));
      return updatedCart;
    });
  };
  

 const supprimerArticle = (id) => {
    setCart((prevCart) => prevCart.filter((item) => item.id !== id));
  };

  const emptyCart = () => {
    setCart([]);
  };
  
  
  const augmenterQuantite = (id) => {
    setCart((prevCart) =>
      prevCart.map((item) =>
        item.id === id ? { ...item, quantity: item.quantity + 1 } : item
      )
    );
  };
  const diminuerQuantite = (id) => {
    setCart((prevCart) =>
      prevCart
        .map((item) =>
          item.id === id && item.quantity > 1
            ? { ...item, quantity: item.quantity - 1 }
            : item
        )
        .filter((item) => item.quantity > 0)
    );
  };


  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message);
    } else if (type === "error") {
      toast.error(message);
    } else {
      toast.info(message);
    }
  };


  return (
    <>
    <LanguageProvider>
      <Header cartCount={cartCount} removeItemFromCart={removeItemFromCart} supprimerArticle={supprimerArticle} emptyCart={emptyCart}/>
      <main>
        <Outlet context={{incrementCartCount,notify, addToCart, augmenterQuantite,removeItemFromCart , totalAmount, supprimerArticle, diminuerQuantite, emptyCart}} />
      </main>
      {/* <ToastContainer position="top-right" autoClose={10000} /> */}
      <Footer />
    </LanguageProvider>
    </>
  );
};

export default Layout;
